import { render, staticRenderFns } from "./PrePostSender.vue?vue&type=template&id=f5446b1a"
import script from "./PrePostSender.vue?vue&type=script&lang=js"
export * from "./PrePostSender.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports